

/* BEGIN motorcycle-luggage-straps-buyer-highlights-20260731 */
;(function () {
  var expected = ["The adjustable strap extends from 59–90 cm (23.2–35.4 in) to fit different luggage setups.","A secure KAM buckle and high-strength lead-zinc alloy hook provide durable attachment hardware.","Pull the round release button to open the hook buckle and connect the strap to compatible MOLLE webbing."];
  function applyBuyerHighlights() {
    if (window.location.pathname.indexOf('/products/seibertron-adjustable-motorcycle-straps-for-luggage') === -1) return;
    var box = document.querySelector('.auto-product__buyer-fit');
    if (!box) return;
    var items = box.querySelectorAll('li');
    if (items.length < 3) return;
    for (var i = 0; i < 3; i += 1) { if (items[i].textContent !== expected[i]) items[i].textContent = expected[i]; }
  }
  applyBuyerHighlights();
  [80, 250, 800, 1800, 4000].forEach(function (delay) { window.setTimeout(applyBuyerHighlights, delay); });
  new MutationObserver(applyBuyerHighlights).observe(document.documentElement, { childList: true, subtree: true });
})();
/* END motorcycle-luggage-straps-buyer-highlights-20260731 */
